<div *ngIf="items?.length" [style.text-align]="'center'" [style.padding-top]="topSpacing">
  <table style="width: auto !important; margin: 0 auto; border-collapse: collapse;">
    <tr>
      <td style="width: auto !important; vertical-align: middle; text-align: center !important; padding: 0 3px 0 0 !important;">
        <img [src]="logoUrl" alt="FBR Digital Invoicing" style="display: block; width: 22mm; height: auto;" />
      </td>
      <td style="width: auto !important; vertical-align: middle; text-align: center !important; padding: 0 0 0 3px !important;">
        <img *ngFor="let item of items" [src]="item.qr" alt="FBR QR" style="display: block; width: 25mm; height: 25mm;" />
      </td>
    </tr>
  </table>
  <div *ngFor="let item of items" style="margin-top: 2px; font-size: 10px; font-weight: bold; color: black; word-break: break-all; overflow-wrap: anywhere; white-space: normal;">FBR-InvoiceID: {{ item.id }}</div>
</div>
